import { Header, Popup, Table } from '@mairistem/composants';
import { formatMontant, Icon } from '@mairistem/finances-utils';
import React from 'react';
import type { IdeeOrigine } from '../../../../interfaces/simulation/montantSimulation';

interface OrigineIdeePopupProps {
	// Montant budgete : le demande de la demande issue de l'idee
	demande: number;
	idee: IdeeOrigine;
}

// Infobulle de l'origine Ideation : rappel de l'idee Vision 360. Le Popup est
// rendu dans un portail, au-dessus de la modale et sans defilement horizontal
const OrigineIdeePopup = ({ demande, idee }: OrigineIdeePopupProps) => (
	<Popup
		content={
			<div data-testid="origineIdee">
				<Header
					content={`Idée liée · Vision 360 · ID-${idee.numero}`}
					size="tiny"
					subheader={idee.libelle}
				/>
				<Table basic="very" compact="very" unstackable>
					<Table.Body>
						<Table.Row>
							<Table.Cell>Montant de l'idée</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(idee.montant)}
							</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Montant budgété</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(demande)}
							</Table.Cell>
						</Table.Row>
						{idee.auteur && (
							<Table.Row>
								<Table.Cell>Créée par</Table.Cell>
								<Table.Cell textAlign="right">{idee.auteur}</Table.Cell>
							</Table.Row>
						)}
					</Table.Body>
				</Table>
			</div>
		}
		position="top center"
		trigger={
			<span data-testid="origineIdeeTrigger">
				<Icon
					color="grey"
					cursor="help"
					iconSet="Lucide"
					name="Info"
					size={15}
				/>
			</span>
		}
		wide
	/>
);

export default OrigineIdeePopup;
